/* global t */
// Help articles for using Plumme through an external AI client over MCP.
window.PlummeHelpArticlePacks = (window.PlummeHelpArticlePacks || []).concat([() => ({
  mcpConnect: { id: 'mcpConnect', title: t('ha.mcpConnect.title'), category: t('ha.cat.mcp'), read: t('ha.read3'), route: 'innstillinger',
    keywords: t('ha.mcpConnect.keywords'),
    lead: t('ha.mcpConnect.lead'),
    blocks: [
    { t: 'step', n: 1, title: t('ha.mcpConnect.open'), text: t('ha.mcpConnect.openText') },
    { t: 'step', n: 2, title: t('ha.mcpConnect.add'), text: t('ha.mcpConnect.addText') },
    { t: 'step', n: 3, title: t('ha.mcpConnect.authorize'), text: t('ha.mcpConnect.authorizeText') },
    { t: 'step', n: 4, title: t('ha.mcpConnect.test'), text: t('ha.mcpConnect.testText') },
    { t: 'tip', kind: 'info', title: t('ha.mcpConnect.cost'), text: t('ha.mcpConnect.costText') },
    { t: 'tip', kind: 'warn', title: t('ha.mcpConnect.scope'), text: t('ha.mcpConnect.scopeText') }]
  },
  mcpReceipts: { id: 'mcpReceipts', title: t('ha.mcpReceipts.title'), category: t('ha.cat.mcp'), read: t('ha.read3'), route: 'innstillinger',
    keywords: t('ha.mcpReceipts.keywords'),
    lead: t('ha.mcpReceipts.lead'),
    blocks: [
    { t: 'step', n: 1, title: t('ha.mcpReceipts.send'), text: t('ha.mcpReceipts.sendText') },
    { t: 'step', n: 2, title: t('ha.mcpReceipts.analyze'), text: t('ha.mcpReceipts.analyzeText') },
    { t: 'step', n: 3, title: t('ha.mcpReceipts.propose'), text: t('ha.mcpReceipts.proposeText') },
    { t: 'step', n: 4, title: t('ha.mcpReceipts.approve'), text: t('ha.mcpReceipts.approveText') },
    { t: 'tip', kind: 'info', title: t('ha.mcpReceipts.fallback'), text: t('ha.mcpReceipts.fallbackText') },
    { t: 'tip', kind: 'warn', title: t('ha.mcpReceipts.check'), text: t('ha.mcpReceipts.checkText') }]
  },
  mcpApprovals: { id: 'mcpApprovals', title: t('ha.mcpApprovals.title'), category: t('ha.cat.mcp'), read: t('ha.read3'), route: 'innstillinger',
    keywords: t('ha.mcpApprovals.keywords'),
    lead: t('ha.mcpApprovals.lead'),
    blocks: [
    { t: 'step', n: 1, title: t('ha.mcpApprovals.draft'), text: t('ha.mcpApprovals.draftText') },
    { t: 'step', n: 2, title: t('ha.mcpApprovals.open'), text: t('ha.mcpApprovals.openText') },
    { t: 'step', n: 3, title: t('ha.mcpApprovals.review'), text: t('ha.mcpApprovals.reviewText') },
    { t: 'step', n: 4, title: t('ha.mcpApprovals.disconnect'), text: t('ha.mcpApprovals.disconnectText') },
    { t: 'tip', kind: 'warn', title: t('ha.mcpApprovals.expiry'), text: t('ha.mcpApprovals.expiryText') },
    { t: 'tip', kind: 'info', title: t('ha.mcpApprovals.limit'), text: t('ha.mcpApprovals.limitText') }]
  }
})]);
